import moment from 'moment'
import {FORMACTIVED, NEWTAB} from '../../insurance/healthInsurance/redux/action'
import * as Effects from 'redux-saga/effects'
import {
  ActionTypes,
  ADDITIONALBENEFIT,
  BUYERID,
  CARINFOBANCAS,
  CONTRACTOBJID,
  CURRENCYINFO,
  CUSTOMERID,
  FEEINSURANCE,
  FIELDINPUT,
  LISTBUSSINESSDETAILS,
  LISTOBJECTINSURED,
  OBJECTINSURED,
  OBJECTINSUREDINFO,
  PACKAGEBENEFITS,
  RELATIONSHIP,
  TABINSURED,
  UPDATECONTRACTID,
} from './actions'
import {bancasInitialState} from './model'
import {
  step3GetObjectInsuredById,
  step3GetObjectInsuredByIdentity,
  calculatorFeeHelthCare,
} from '../../insurance/healthInsurance/apis'
import {step3GetObjectInsuredCarByID} from '../../insurance/AutoInsurance/apis'
import {step2GetObjectInsuredMotoByID} from '../../insurance/MotoInsurance/apis'
import {getHouseInsuredById} from '../../insurance/InsuranceProducts/apis'
import {calculateDate, CalculateTimeInsured, formatter, validateSpecialChar} from '../../../utils'

const call: any = Effects.call
const takeLatest = Effects.takeLatest
const put = Effects.put

export const actions = {
  addNewTab: (tab: NEWTAB) => ({type: 'ADDNEWBANCASTAB', payload: tab}),
  removeTab: (tab: string) => ({type: 'REMOVEBANCASTAB', payload: tab}),
  addListPackages: (data: any) => ({type: 'ADDLISTPACKAGES', payload: data}),
  addListBussinessDetails: (data: LISTBUSSINESSDETAILS) => ({
    type: 'ADDLISTBUSSINESSDETAILS',
    payload: data,
  }),
  addBancasInfors: (data: OBJECTINSUREDINFO) => ({type: 'ADDBANCASINFORS', payload: data}),
  updateListObjectInsured: (data: TABINSURED) => ({type: 'UPDATELISTOBJECTINSURED', payload: data}),
  removeObjectInsured: (data: TABINSURED) => ({type: 'REMOVEOBJECTINSURED', payload: data}),
  modifyObjectInsured: (data: TABINSURED) => ({type: 'MODIFYOBJECTINSURED', payload: data}),
  clearDataForm: (data: OBJECTINSURED) => ({type: 'CLEARDATAFORM', payload: data}),
  refreshInitialState: () => ({type: 'REFRESHINITIALSTATE'}),
  updateFieldInput: (data: FIELDINPUT) => ({type: 'UPDATEFIELDINPUT', payload: data}),
  updateObjectInsuredAdditionalBenefits: (data: ADDITIONALBENEFIT) => ({
    type: 'UPDATEADDITONALBENEFITS',
    payload: data,
  }),
  getListPersonInsured: (data: LISTOBJECTINSURED) => ({
    type: 'GETLISTPERSONINSURED',
    payload: data,
  }),
  getListCarBancasInsured: (data: LISTOBJECTINSURED) => ({
    type: 'GETLISTCARBANCASINSURED',
    payload: data,
  }),
  getPersonInsuredById: (data: any) => ({type: 'GETPERSONINSUREDBYID', payload: data}),
  savePersonInsuredById: (data: any) => ({type: 'SAVEPERSONINSUREDBYID', payload: data}),
  getCarInsuredById: (data: any) => ({type: 'GETCARBANCASINSUREDBYID', payload: data}),
  saveCarInsuredById: (data: any) => ({type: 'SAVECARBANCASINSUREDBYID', payload: data}),
  getListMotoInsured: (data: LISTOBJECTINSURED) => ({
    type: 'GETLISTMOTOBANCASINSURED',
    payload: data,
  }),
  getMotoInsuredById: (data: any) => ({type: 'GETMOTOBANCASINSUREDBYID', payload: data}),
  saveMotoInsuredById: (data: any) => ({type: 'SAVEMOTOBANCASINSUREDBYID', payload: data}),
  getCustomerInfo: (data: LISTOBJECTINSURED) => ({type: 'GETCUSTOMERINFO', payload: data}),
  updatePackageBenefits: (data: PACKAGEBENEFITS) => ({
    type: 'UPDATEPACKAGEBENEFITS',
    payload: data,
  }),
  updateFeeInsurance: (data: FEEINSURANCE) => ({
    type: 'UPDATEFEEINSURANCE',
    payload: data,
  }),
  updateBuyerByRelationship: (data: RELATIONSHIP) => ({
    type: 'UPDATEBUYERINFOBYRELATIONSHIP',
    payload: data,
  }),
  updateFormStatus: (data: any) => ({type: 'UPDATEFORMSTATUS', payload: data}),
  updateGroupDomainCode: (data: any) => ({type: 'UPDATEGROUPDOMAINCODE', payload: data}),
  updateCurrency: (data: CURRENCYINFO) => ({type: 'UPDATECURRENCY', payload: data}),
  updateContractId: (data: any) => ({type: 'UPDATECONTRACTID', payload: data}),
  updateContractObjId: (data: CONTRACTOBJID) => ({type: 'UPDATECONTRACTOBJID', payload: data}),
  activeFormBancas: (active: FORMACTIVED) => ({type: 'ACTIVEFORMBANCAS', payload: active}),
  getCustomerById: (data: CUSTOMERID) => ({type: 'GETCUSTOMERINFOBYIDENTITY', payload: data}),
  saveCustomerById: (data: any) => ({type: 'SAVECUSTOMERINFOBYIDENTITY', payload: data}),
  getBuyerById: (data: BUYERID) => ({type: 'GETBUYERINFOBYIDENTITY', payload: data}),
  saveBuyerById: (data: any) => ({type: 'SAVEBUYERINFOBYIDENTITY', payload: data}),
  updateCustomerId: (data: BUYERID) => ({type: 'UPDATECUSTOMERID', payload: data}),
  getListHouseInsured: (data: LISTOBJECTINSURED) => ({
    type: 'GETLISTHOUSEBANCASINSURED',
    payload: data,
  }),
  getHouseInsuredById: (data: any) => ({type: 'GETHOUSEBANCASINSUREDBYID', payload: data}),
  saveHouseInsuredById: (data: any) => ({type: 'SAVEHOUSEBANCASINSUREDBYID', payload: data}),
  updateDiscount: (data: any) => ({type: 'UPDATEDISCOUNT', payload: data}),
  updateCarInfoBancas: (data: CARINFOBANCAS) => ({type: 'UPDATECARINFOBANCAS', payload: data}),
}

export const bancasReducer = (state = bancasInitialState, action: ActionTypes | any) => {
  switch (action.type) {
    case 'ADDNEWBANCASTAB':
      const newTabState = JSON.parse(JSON.stringify(state))
      if (newTabState.length === 1 && newTabState[0].tabName == undefined) {
        newTabState[0].tabName = action.payload.tab
        newTabState[0].sellingContractId = action.payload.tab
        newTabState[0].customerCode = action.payload.customerCode
        newTabState[0].customerVersion = action.payload.customerVersion
        newTabState[0].groupDomainCode = action.payload.groupDomainCode
      } else {
        const obj = {
          tabName: action.payload.tab,
          sellingContractId: action.payload.tab,
          customerCode: action.payload.customerCode,
          customerVersion: action.payload.customerVersion,
          groupDomainCode: action.payload.groupDomainCode,
          packageInsurance: undefined,
          form: {
            activeForm: 1,
            fieldInput: undefined,
            formStatus: undefined,
            currencyFee: undefined,
            currencyMoney: undefined,
            formData: {
              formObjectInsured: [
                {
                  id: 0,
                  type: null,
                  timeDuration: '1',
                  customerName: null,
                  addressName: null,
                  startDate: moment().format('YYYY/MM/DD HH:mm'),
                  expireDate: calculateDate(moment().format('YYYY/MM/DD HH:mm'), true),
                  gender: null,
                  relationship: null,
                  salary: null,
                  creditContractNumber: null,
                  partner: null,
                  employeeCode: null,
                  position: null,
                  from: null,
                  to: null,
                  loanType: null,
                  loanAmount: null,
                  loanTime: null,
                  EMIField: null,
                  certType: '1',
                  certNumber: null,
                  hasLicense: '1',
                  licensePlate: null,
                  chassisNumber: null,
                  engineNumber: null,
                  carCompany: null,
                  carBrand: null,
                  manufacturingYear: moment().year().toString(),
                  seat: '5',
                  driverNumber: '0',
                  capacity: '0',
                  purposeOfUseType: '2',
                  price: '500,000,000',
                  vehiclePackageBenefitDtos: [],
                  vehiclePackageExtensionDtos: [],
                  additionalBenefit: [],
                  vehicleGroupsCode: null,
                  payload: '0',
                  packageCode: null,
                  businessProgramCode: null,
                  customerBirthDay: null,
                  identificationNumber: null,
                  mobile: null,
                  email: null,
                  sumFee: null,
                  sumTax: null,
                  objectInsuredType: 1,
                  customerSource: 0,
                  customerSegment: 0,
                  coverage: '1',
                  yearBuilt: null,
                  floorNumber: null,
                  ownerType: null,
                  houseType: null,
                  businessHouseType: null,
                  fireFighting: null,
                  sumInsured: null,
                },
              ],
              formInsuranceBuyer: {
                customerName: null,
                identificationNumber: null,
                customerBirthDay: null,
                gender: null,
                taxNumber: null,
                addressName: null,
                phone: null,
                mobile: null,
                email: null,
                loanAmount: null,
                bank: null,
                loanPurpose: null,
                creditContractNumber: null,
                loanTime: null,
                customerType: 2,
                customerSegment: 1,
              },
              listpackages: null,
              listBussinessDetails: undefined,
              feeAdditional: undefined,
            },
          },
        }
        newTabState.push(obj)
      }
      return newTabState
    case 'REMOVEBANCASTAB':
      const removeTabState = JSON.parse(JSON.stringify(state))
      const tabRemoved = removeTabState.filter((o: any) => o.tabName !== action.payload)
      return tabRemoved
    case 'ADDLISTPACKAGES':
      const addProductPackagesTabState = JSON.parse(JSON.stringify(state))
      let addProductPackagesTab = addProductPackagesTabState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (addProductPackagesTab) {
        addProductPackagesTab.form.listpackages = action.payload.dataPackages
      }
      return addProductPackagesTabState
    case 'ADDLISTBUSSINESSDETAILS':
      const addListBussinessDetailsTabState = JSON.parse(JSON.stringify(state))
      let addListBussinessDetailsTab = addListBussinessDetailsTabState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (addListBussinessDetailsTab) {
        addListBussinessDetailsTab.form.formData.listBussinessDetails = action.payload.details
      }
      return addListBussinessDetailsTabState
    case 'UPDATECURRENCY':
      const updateCurrencyTabState = JSON.parse(JSON.stringify(state))
      let updateCurrencyDetailsTab = updateCurrencyTabState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (updateCurrencyDetailsTab) {
        updateCurrencyDetailsTab.form.currencyFee = action.payload.currencyFee
        updateCurrencyDetailsTab.form.currencyMoney = action.payload.currencyMoney
      }
      return updateCurrencyTabState
    case 'ADDBANCASINFORS':
      const addProductTabState = JSON.parse(JSON.stringify(state))
      const {key, value, tab, form, objectSelected} = action.payload
      let addProductTab = addProductTabState.find((o: any) => o.tabName == tab)
      if (addProductTab) {
        if (form == 'formObjectInsured') {
          addProductTab.form.formData[form][objectSelected][key] = value
          // if (key == 'salary' || key == 'price') {
          //   if (value && value !== '' && typeof value == 'string') {
          //     let convert = value.replaceAll(',', '')
          //     if (!isNaN(parseInt(convert))) {
          //       let test = validateSpecialChar(value)
          //       if (!test) {
          //         addProductTab.form.formData[form][objectSelected][key] = formatter(
          //           parseInt(convert)
          //         )
          //       } else
          //         addProductTab.form.formData[form][objectSelected][key] = formatter(
          //           parseInt(value)
          //         )
          //     } else addProductTab.form.formData[form][objectSelected][key] = null
          //   } else if (typeof value == 'number') {
          //     addProductTab.form.formData[form][objectSelected][key] = formatter(value)
          //   }
          // }
          if (key == 'startDate') {
            let dataCalculated = calculateDate(value, true)
            if (
              addProductTab.form.formData[form][objectSelected].loanTime &&
              addProductTab.form.formData[form][objectSelected].loanTime > '1'
            ) {
              dataCalculated = calculateDate(
                value,
                true,
                addProductTab.form.formData[form][objectSelected].loanTime
              )
            }
            addProductTab.form.formData[form][objectSelected].expireDate = dataCalculated
          }
          if (key == 'loanTime') {
            let dataCalculated = calculateDate(
              addProductTab.form.formData[form][objectSelected].startDate,
              true,
              value
            )
            addProductTab.form.formData[form][objectSelected].expireDate = dataCalculated
          }
        } else addProductTab.form.formData[form][key] = value
      }
      return addProductTabState
    case 'UPDATELISTOBJECTINSURED':
      const updateListObjectInsuredState = JSON.parse(JSON.stringify(state))
      let updateListObjectInsuredTab = updateListObjectInsuredState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (updateListObjectInsuredTab) {
        if (action.payload.objectInsured) {
          let check = updateListObjectInsuredTab.form.formData.formObjectInsured.find(
            (o: any) => o.id == action.payload.objectInsured?.id
          )
          if (check && action.payload.objectSelected) {
            updateListObjectInsuredTab.form.formData.formObjectInsured[
              action.payload.objectSelected
            ] = {
              ...check,
              ...action.payload.objectInsured,
            }
          } else
            updateListObjectInsuredTab.form.formData.formObjectInsured.push(
              action.payload.objectInsured
            )
        }
      }
      return updateListObjectInsuredState
    case 'REMOVEOBJECTINSURED':
      const deleteObjectInsuredState = JSON.parse(JSON.stringify(state))
      let deleteObjectInsuredTab = deleteObjectInsuredState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (deleteObjectInsuredTab) {
        deleteObjectInsuredTab.form.formData.formObjectInsured =
          deleteObjectInsuredTab.form.formData.formObjectInsured.filter(
            (o: any) => o.id != action.payload.check
          )
      }
      return deleteObjectInsuredState
    case 'CLEARDATAFORM':
      const clearObjectInsuredState = JSON.parse(JSON.stringify(state))
      let clearObjectInsuredTab = clearObjectInsuredState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (clearObjectInsuredTab) {
        for (const key in clearObjectInsuredTab.form.formData.formObjectInsured[
          action.payload.objectSelected
        ]) {
          if (
            key == 'additionalBenefit' ||
            key == 'vehiclePackageBenefitDtos' ||
            key == 'vehiclePackageExtensionDtos'
          ) {
            clearObjectInsuredTab.form.formData.formObjectInsured[action.payload.objectSelected][
              key
            ] = []
          } else if (key == 'startDate') {
            clearObjectInsuredTab.form.formData.formObjectInsured[action.payload.objectSelected][
              key
            ] = moment().format('YYYY/MM/DD HH:mm')
          } else if (key == 'expireDate') {
            clearObjectInsuredTab.form.formData.formObjectInsured[action.payload.objectSelected][
              key
            ] = calculateDate(moment().format('YYYY/MM/DD HH:mm'), true)
          } else if (
            key != 'businessProgramCode' &&
            key != 'id' &&
            key != 'objectInsuredType' &&
            key != 'customerSource' &&
            key != 'customerSegment' &&
            key != 'coverage' &&
            key != 'hasLicense' &&
            key != 'packageCode'
          ) {
            clearObjectInsuredTab.form.formData.formObjectInsured[action.payload.objectSelected][
              key
            ] = null
          }
        }
      }
      return clearObjectInsuredState
    case 'REFRESHINITIALSTATE':
      state.length = 0
      const initialState = {
        tabName: undefined,
        sellingContractId: undefined,
        customerCode: undefined,
        customerVersion: undefined,
        groupDomainCode: undefined,
        packageInsurance: undefined,
        form: {
          activeForm: 1,
          fieldInput: undefined,
          formStatus: undefined,
          currencyFee: undefined,
          currencyMoney: undefined,
          formData: {
            formObjectInsured: [
              {
                id: 0,
                type: null,
                timeDuration: '1',
                customerName: null,
                addressName: null,
                startDate: moment().format('YYYY/MM/DD HH:mm'),
                expireDate: calculateDate(moment().format('YYYY/MM/DD HH:mm'), true),
                gender: null,
                relationship: null,
                salary: null,
                creditContractNumber: null,
                partner: null,
                employeeCode: null,
                position: null,
                from: null,
                to: null,
                loanType: null,
                loanAmount: null,
                loanTime: null,
                EMIField: null,
                certType: '1',
                certNumber: null,
                hasLicense: '1',
                licensePlate: null,
                chassisNumber: null,
                engineNumber: null,
                carCompany: null,
                carBrand: null,
                manufacturingYear: moment().year().toString(),
                seat: '5',
                driverNumber: '0',
                capacity: '0',
                purposeOfUseType: '2',
                price: '500,000,000',
                vehiclePackageBenefitDtos: [],
                vehiclePackageExtensionDtos: [],
                additionalBenefit: [],
                vehicleGroupsCode: null,
                payload: '0',
                packageCode: null,
                businessProgramCode: null,
                customerBirthDay: null,
                identificationNumber: null,
                mobile: null,
                email: null,
                sumFee: null,
                sumTax: null,
                objectInsuredType: 1,
                customerSource: 0,
                customerSegment: 0,
                coverage: '1',
                yearBuilt: null,
                floorNumber: null,
                ownerType: null,
                houseType: null,
                businessHouseType: null,
                fireFighting: null,
                sumInsured: null,
              },
            ],
            formInsuranceBuyer: {
              customerName: null,
              identificationNumber: null,
              customerBirthDay: null,
              gender: null,
              taxNumber: null,
              addressName: null,
              employeeCode: null,
              parentGroupCode: null,
              phone: null,
              mobile: null,
              email: null,
              loanAmount: null,
              bank: null,
              loanPurpose: null,
              creditContractNumber: null,
              loanTime: null,
              customerType: 2,
              customerSegment: 1,
            },
            listpackages: null,
            listBussinessDetails: undefined,
            feeAdditional: undefined,
          },
        },
      }
      state.push(initialState)
      return state
    case 'UPDATEFIELDINPUT':
      const fieldInputState = JSON.parse(JSON.stringify(state))
      let fieldInputTab = fieldInputState.find((o: any) => o.tabName == action.payload.tab)
      if (fieldInputTab) {
        fieldInputTab.form.fieldInput = action.payload.listFieldInput
      }
      return fieldInputState
    case 'UPDATEPACKAGEBENEFITS':
      const packageBenefitsState = JSON.parse(JSON.stringify(state))
      let packageBenefitsTab = packageBenefitsState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (packageBenefitsTab) {
        packageBenefitsTab.form.formData.formObjectInsured[
          action.payload.objectSelected
        ].vehiclePackageBenefitDtos = action.payload.benefits
        packageBenefitsTab.form.formData.formObjectInsured[
          action.payload.objectSelected
        ].vehiclePackageExtensionDtos = action.payload.extensions
        if (action.payload.benefits.length == 0)
          packageBenefitsTab.form.formData.formObjectInsured[
            action.payload.objectSelected
          ].additionalExtensions = []
      }
      return packageBenefitsState
    case 'UPDATEFEEINSURANCE':
      const feeInsuranceState = JSON.parse(JSON.stringify(state))
      let feeInsuranceTab = feeInsuranceState.find((o: any) => o.tabName == action.payload.tab)
      if (feeInsuranceTab) {
        feeInsuranceTab.form.formData.formObjectInsured[action.payload.objectSelected].sumFee =
          action.payload.sumFee
        feeInsuranceTab.form.formData.formObjectInsured[action.payload.objectSelected].sumTax =
          action.payload.sumTax
      }
      return feeInsuranceState
    case 'UPDATEADDITONALBENEFITS':
      const additionalBenefitState = JSON.parse(JSON.stringify(state))
      let additionalBenefitTab = additionalBenefitState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (additionalBenefitTab) {
        let object =
          additionalBenefitTab.form.formData.formObjectInsured[action.payload.objectSelected]
        if (action.payload.checked) {
          object.additionalBenefit.push(action.payload.benefit)
        } else {
          object.additionalBenefit = object.additionalBenefit.filter(
            (o: any) => o != action.payload.benefit
          )
        }
      }
      return additionalBenefitState
    case 'GETLISTPERSONINSURED':
      const listObjectInsuredState = JSON.parse(JSON.stringify(state))
      let listObjectInsuredTab = listObjectInsuredState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (listObjectInsuredTab) {
        action.payload.listObjectInsured.map((o: any) => {
          let check = listObjectInsuredTab.form.formData.formObjectInsured.find(
            (c: any) => c.id == o.id
          )
          if (check) return
          let obj = {
            id: o.id,
            type: null,
            timeDuration: '1',
            customerName: o.objectInsuredInfo.name,
            addressName: o.objectInsuredInfo.addressName,
            startDate: o.startDate
              ? moment(o.startDate, 'DD/MM/YYYY  HH:mm').format('YYYY/MM/DD  HH:mm')
              : null,
            expireDate: o.expireDate
              ? moment(o.expireDate, 'DD/MM/YYYY  HH:mm').format('YYYY/MM/DD  HH:mm')
              : null,
            gender: o.objectInsuredInfo.gender.toString(),
            relationship: o.objectInsuredPeopleDtos
              ? o.objectInsuredPeopleDtos[0].relationsShip
              : null,
            salary: null,
            creditContractNumber: null,
            partner: null,
            employeeCode: null,
            position: null,
            from: null,
            to: null,
            loanType: null,
            loanAmount: null,
            loanTime: null,
            EMIField: null,
            certNumber: o.certNumber,
            certType: o.certType,
            hasLicense: '1',
            licensePlate: null,
            chassisNumber: null,
            engineNumber: null,
            carCompany: null,
            carBrand: null,
            manufacturingYear: null,
            seat: null,
            driverNumber: null,
            capacity: null,
            purposeOfUseType: '2',
            price: '500,000,000',
            vehiclePackageBenefitDtos: [],
            vehiclePackageExtensionDtos: [],
            additionalBenefit: o.addtionalBenefit ? o.addtionalBenefit.split(',') : [],
            vehicleGroupsCode: null,
            payload: null,
            businessProgramCode: o.businessProgramCode,
            packageCode: o.packageCode,
            customerBirthDay: o.objectInsuredInfo.birthday
              ? moment(o.objectInsuredInfo.birthday, 'DD/MM/YYYY').format('YYYY/MM/DD')
              : null,
            identificationNumber: o.objectInsuredInfo.identificationNumber,
            mobile: o.objectInsuredInfo.phone,
            email: o.objectInsuredInfo.email,
            sumFee: o?.sumFeeOrg ? o.sumFeeOrg : o.sumFee,
            sumTax: null,
            objectInsuredType: 1,
            customerSource: 0,
            customerSegment: 0,
            coverage: '1',
            sumInsured: o?.sumInsured ? formatter(o.sumInsured) : null,
          }
          listObjectInsuredTab.form.formData.formObjectInsured.push(obj)
        })
        listObjectInsuredTab.form.formData.formObjectInsured[0].businessProgramCode =
          listObjectInsuredTab.form.formData.formObjectInsured[1].businessProgramCode
        let obj = {
          id: action.payload.listObjectInsured[0].id,
          sellingContractId: listObjectInsuredTab.sellingContractId,
        }
        step3GetObjectInsuredById(obj)
          .then((res: any) => {
            if (res && !res.isError) {
              action.asyncDispatch({type: 'SAVEPERSONINSUREDBYID', payload: res.data})
            }
          })
          .catch((error) => {
            return
          })
      }
      return listObjectInsuredState
    case 'GETLISTCARBANCASINSURED':
      const listCarInsuredState = JSON.parse(JSON.stringify(state))
      let listCarInsuredTab = listCarInsuredState.find((o: any) => o.tabName == action.payload.tab)
      if (listCarInsuredTab) {
        action.payload.listObjectInsured.map((o: any) => {
          if (listCarInsuredTab.form.formData.formObjectInsured.find((c: any) => c.id == o.id))
            return
          if (o._sellingContractCarBenefitDtos && o._sellingContractCarBenefitDtos.length > 0) {
            o._sellingContractCarBenefitDtos.forEach((elem: any) => {
              elem.isChecked = true
            })
          }
          if (o._sellingContractCarExtensionDtos && o._sellingContractCarExtensionDtos.length > 0) {
            let arr: any = []
            o._sellingContractCarExtensionDtos.forEach((elem: any) => {
              elem.isChecked = true
              elem.code = elem.extensionCode
              elem.name = elem.extensionName
              arr.push(elem.extensionCode)
            })
            o.additionalExtensions = arr
          }
          let obj = {
            id: o.id,
            type: null,
            timeDuration: '1',
            customerName: o._sellingContractCarDtos[0].vehicleOwner,
            addressName: o._sellingContractCarDtos[0].address,
            startDate: o.startDate
              ? moment(o.startDate, 'DD/MM/YYYY  HH:mm').format('YYYY/MM/DD  HH:mm')
              : null,
            expireDate: o.expireDate
              ? moment(o.expireDate, 'DD/MM/YYYY  HH:mm').format('YYYY/MM/DD  HH:mm')
              : null,
            gender: null,
            relationship: null,
            salary: null,
            creditContractNumber: null,
            partner: null,
            employeeCode: null,
            position: null,
            from: null,
            to: null,
            loanType: null,
            loanAmount: null,
            loanTime: null,
            EMIField: null,
            certNumber: o.certNumber,
            certType: o.certType,
            hasLicense: '1',
            licensePlate: o._sellingContractCarDtos[0].licensePlate,
            chassisNumber: o._sellingContractCarDtos[0].chassisNumber,
            engineNumber: null,
            carCompany: o._sellingContractCarDtos[0].carCompany,
            carBrand: o._sellingContractCarDtos[0].carBrand,
            manufacturingYear: o._sellingContractCarDtos[0].manufacturingYear.toString(),
            seat: o._sellingContractCarDtos[0].seat,
            driverNumber: o._sellingContractCarDtos[0].driverNumber
              ? o._sellingContractCarDtos[0].driverNumber.toString()
              : '0',
            capacity: o._sellingContractCarDtos[0].capacity
              ? o._sellingContractCarDtos[0].driverNumber.toString()
              : '0',
            purposeOfUseType: o._sellingContractCarDtos[0].purposeOfUseType,
            price: o._sellingContractCarDtos[0].price
              ? formatter(o._sellingContractCarDtos[0].price)
              : null,
            vehiclePackageBenefitDtos: o._sellingContractCarBenefitDtos,
            vehiclePackageExtensionDtos: o._sellingContractCarExtensionDtos,
            additionalBenefit: [],
            additionalExtensions: o.additionalExtensions ? o.additionalExtensions : [],
            vehicleGroupsCode: o._sellingContractCarDtos[0].vehicleGroupsCode,
            payload: o._sellingContractCarDtos[0].payload,
            businessProgramCode: null,
            packageCode: o.packageCode.substring(0, o.packageCode.lastIndexOf('_')),
            customerBirthDay: null,
            identificationNumber: null,
            mobile: null,
            email: null,
            sumFee: o.sumFeeOrg ? o.sumFeeOrg : o.sumFee,
            sumTax: o.sumTaxOrg ? o.sumTaxOrg : o.sumTax,
            objectInsuredType: 1,
            customerSource: 0,
            customerSegment: 0,
            coverage: '1',
            sumInsured: null,
          }

          listCarInsuredTab.form.formData.formObjectInsured.push(obj)
        })
        let data: any = {
          sellingContractId: listCarInsuredTab.sellingContractId,
          id: action.payload.listObjectInsured[0].id,
        }
        step3GetObjectInsuredCarByID(data)
          .then((res: any) => {
            if (res && !res.isError) {
              action.asyncDispatch({type: 'SAVECARBANCASINSUREDBYID', payload: res.data})
            }
          })
          .catch((error) => {
            return
          })
      }
      return listCarInsuredState
    case 'GETPERSONINSUREDBYID':
      return state
    case 'SAVEPERSONINSUREDBYID':
      const objectInsuredByIdState = JSON.parse(JSON.stringify(state))
      let objInsuredByIdTab = objectInsuredByIdState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId.toString()
      )
      if (objInsuredByIdTab) {
        let test = objInsuredByIdTab.form.formData.formObjectInsured.find(
          (o: any) => o.id == action.payload.id
        )
        if (test) {
          if (action.payload.addtionalBenefit && action.payload.addtionalBenefit.length > 0) {
            test.additionalBenefit = action.payload.addtionalBenefit.split(',')
          }
          test.sumInsured = action.payload.sumInsured ? formatter(action.payload.sumInsured) : null
        }
      }
      return objectInsuredByIdState
    case 'GETCARBANCASINSUREDBYID':
      return state
    case 'SAVECARBANCASINSUREDBYID':
      const carInsuredByIdState = JSON.parse(JSON.stringify(state))
      let carInsuredByIdTab = carInsuredByIdState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId.toString()
      )
      if (carInsuredByIdTab) {
        let test = carInsuredByIdTab.form.formData.formObjectInsured.find(
          (o: any) => o.id == action.payload.id
        )
        if (test) {
          if (
            action.payload._sellingContractCarBenefitDtos &&
            action.payload._sellingContractCarBenefitDtos.length > 0
          ) {
            action.payload._sellingContractCarBenefitDtos.forEach((elem: any) => {
              elem.isChecked = true
            })
          }
          if (
            action.payload._sellingContractCarExtensionDtos &&
            action.payload._sellingContractCarExtensionDtos.length > 0
          ) {
            let arr: any = []
            action.payload._sellingContractCarExtensionDtos.forEach((elem: any) => {
              elem.isChecked = true
              elem.code = elem.extensionCode
              arr.push(elem.extensionCode)
            })
            test.additionalExtensions = arr
          }
          test.vehiclePackageBenefitDtos = action.payload._sellingContractCarBenefitDtos
          test.vehiclePackageExtensionDtos = action.payload._sellingContractCarExtensionDtos
          test.callCalculateFee = true
        }
      }
      return carInsuredByIdState
    case 'GETLISTMOTOBANCASINSURED':
      const listMotoInsuredState = JSON.parse(JSON.stringify(state))
      let listMotoInsuredTab = listMotoInsuredState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (listMotoInsuredTab) {
        action.payload.listObjectInsured.map((o: any) => {
          if (listMotoInsuredTab.form.formData.formObjectInsured.find((c: any) => c.id == o.id))
            return
          if (o._sellingContractBikeBenefitDtos && o._sellingContractBikeBenefitDtos.length > 0) {
            o._sellingContractBikeBenefitDtos.forEach((elem: any) => {
              elem.isChecked = true
            })
          }
          let obj = {
            id: o.id,
            type: null,
            timeDuration: CalculateTimeInsured(
              moment(o.startDate, 'DD/MM/YYYY  HH:mm').format('YYYY/MM/DD'),
              moment(o.expireDate, 'DD/MM/YYYY  HH:mm').format('YYYY/MM/DD')
            ),
            customerName: o._sellingContractBikeDtos[0].vehicleOwner,
            addressName: o._sellingContractBikeDtos[0].address,
            startDate: o.startDate
              ? moment(o.startDate, 'DD/MM/YYYY  HH:mm').format('YYYY/MM/DD  HH:mm')
              : null,
            expireDate: o.expireDate
              ? moment(o.expireDate, 'DD/MM/YYYY  HH:mm').format('YYYY/MM/DD  HH:mm')
              : null,
            gender: null,
            relationship: null,
            salary: null,
            creditContractNumber: null,
            partner: null,
            employeeCode: null,
            position: null,
            from: null,
            to: null,
            loanType: null,
            loanAmount: null,
            loanTime: null,
            EMIField: null,
            certNumber: o.certNumber,
            certType: o.certType,
            hasLicense: '1',
            licensePlate: o._sellingContractBikeDtos[0].licensePlate,
            chassisNumber: o._sellingContractBikeDtos[0].chassisNumber,
            engineNumber: null,
            carCompany: o._sellingContractBikeDtos[0].bikeCompany,
            carBrand: o._sellingContractBikeDtos[0].bikeBrand,
            manufacturingYear: o._sellingContractBikeDtos[0].manufacturingYear.toString(),
            seat: null,
            driverNumber: null,
            capacity: null,
            purposeOfUseType: '2',
            price: '500,000,000',
            vehiclePackageBenefitDtos: o._sellingContractBikeBenefitDtos
              ? o._sellingContractBikeBenefitDtos
              : [],
            vehiclePackageExtensionDtos: [],
            additionalBenefit: [],
            vehicleGroupsCode: o._sellingContractBikeDtos[0].vehicleGroupsCode,
            payload: null,
            businessProgramCode: null,
            code: null,
            packageCode: o.packageCode,
            customerBirthDay: null,
            identificationNumber: null,
            mobile: null,
            email: null,
            sumFee: o.sumFee,
            sumTax: o.sumTax,
            objectInsuredType: 1,
            customerSource: 0,
            customerSegment: 0,
            coverage: '1',
            sumInsured: null,
          }
          listMotoInsuredTab.form.formData.formObjectInsured.push(obj)
        })
        let data: any = {
          sellingContractId: listMotoInsuredTab.sellingContractId,
          id: action.payload.listObjectInsured[0].id,
        }
        step2GetObjectInsuredMotoByID(data)
          .then((res: any) => {
            if (res && !res.isError) {
              action.asyncDispatch({type: 'SAVEMOTOBANCASINSUREDBYID', payload: res.data})
            }
          })
          .catch((error) => {
            return
          })
      }
      return listMotoInsuredState
    case 'GETMOTOBANCASINSUREDBYID':
      return state
    case 'SAVEMOTOBANCASINSUREDBYID':
      const motoInsuredByIdState = JSON.parse(JSON.stringify(state))
      let motoByIdTab = motoInsuredByIdState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId.toString()
      )
      if (motoByIdTab) {
        let test = motoByIdTab.form.formData.formObjectInsured.find(
          (o: any) => o.id == action.payload.id
        )
        if (test) {
          if (
            action.payload._sellingContractBikeBenefitDtos &&
            action.payload._sellingContractBikeBenefitDtos.length > 0
          ) {
            action.payload._sellingContractBikeBenefitDtos.forEach((elem: any) => {
              elem.isChecked = true
            })
          }
          test.vehiclePackageBenefitDtos = action.payload._sellingContractBikeBenefitDtos
          test.callCalculateFee = true
        }
      }
      return motoInsuredByIdState
    case 'GETLISTHOUSEBANCASINSURED':
      const listHouseInsuredState = JSON.parse(JSON.stringify(state))
      let listHouseInsuredTab = listHouseInsuredState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (listHouseInsuredTab) {
        action.payload.listObjectInsured.map((o: any) => {
          if (listHouseInsuredTab.form.formData.formObjectInsured.find((c: any) => c.id == o.id))
            return
          let obj = {
            id: o.id,
            type: null,
            timeDuration: '1',
            customerName: o._sellingContractHouseDtos[0].name,
            addressName: o._sellingContractHouseDtos[0].address,
            startDate: o.startDate
              ? moment(o.startDate, 'DD/MM/YYYY  HH:mm').format('YYYY/MM/DD  HH:mm')
              : null,
            expireDate: o.expireDate
              ? moment(o.expireDate, 'DD/MM/YYYY  HH:mm').format('YYYY/MM/DD  HH:mm')
              : null,
            gender: null,
            relationship: null,
            salary: null,
            creditContractNumber: null,
            partner: null,
            employeeCode: null,
            position: null,
            from: null,
            to: null,
            loanType: null,
            loanAmount: null,
            loanTime: null,
            EMIField: null,
            certNumber: o.certNumber,
            certType: o.certType,
            hasLicense: '1',
            licensePlate: null,
            chassisNumber: null,
            engineNumber: null,
            carCompany: null,
            carBrand: null,
            manufacturingYear: null,
            seat: null,
            driverNumber: null,
            capacity: null,
            purposeOfUseType: '2',
            price: '500,000,000',
            vehiclePackageBenefitDtos: [],
            vehiclePackageExtensionDtos: [],
            additionalBenefit: [],
            vehicleGroupsCode: null,
            payload: null,
            businessProgramCode: null,
            code: null,
            packageCode: o.packageCode,
            customerBirthDay: null,
            identificationNumber: null,
            mobile: null,
            email: null,
            sumFee: o.sumFee,
            sumTax: o.sumTax,
            objectInsuredType: 1,
            customerSource: 0,
            customerSegment: 0,
            coverage: '1',
            sumInsured: null,
            yearBuilt: o._sellingContractHouseDtos[0].yearBuilt.toString(),
            floorNumber: o._sellingContractHouseDtos[0].floorNumber.toString(),
            ownerType: o._sellingContractHouseDtos[0].ownerType.toString(),
            houseType: o._sellingContractHouseDtos[0].houseType.toString(),
            businessHouseType: o._sellingContractHouseDtos[0].businessHouseType.toString(),
            fireFighting: o._sellingContractHouseDtos[0].fireFighting.toString(),
          }
          listHouseInsuredTab.form.formData.formObjectInsured.push(obj)
        })
        let data: any = {
          sellingContractId: listHouseInsuredTab.sellingContractId,
          id: action.payload.listObjectInsured[0].id,
        }
        getHouseInsuredById(data)
          .then((res: any) => {
            if (res && !res.isError) {
              action.asyncDispatch({type: 'SAVEHOUSEBANCASINSUREDBYID', payload: res.data})
            }
          })
          .catch((error) => {
            return
          })
      }
      return listHouseInsuredState
    case 'GETHOUSEBANCASINSUREDBYID':
      return state
    case 'SAVEHOUSEBANCASINSUREDBYID':
      const houseInsuredByIdState = JSON.parse(JSON.stringify(state))
      let houseByIdTab = houseInsuredByIdState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId.toString()
      )
      if (houseByIdTab) {
        let test = houseByIdTab.form.formData.formObjectInsured.find(
          (o: any) => o.id == action.payload.id
        )
        if (test) {
          if (
            action.payload._sellingContractHouseBenefitDtos &&
            action.payload._sellingContractHouseBenefitDtos.length > 0
          ) {
            action.payload._sellingContractHouseBenefitDtos.forEach((elem: any) => {
              elem.isChecked = true
            })
          }
          test.vehiclePackageBenefitDtos = action.payload._sellingContractHouseBenefitDtos
          test.callCalculateFee = true
        }
      }
      return houseInsuredByIdState
    case 'GETCUSTOMERINFO':
      const customerInfoState = JSON.parse(JSON.stringify(state))
      let customerInfoTab = customerInfoState.find((o: any) => o.tabName == action.payload.tab)
      if (customerInfoTab) {
        customerInfoTab.form.formData.formInsuranceBuyer.customerName =
          action.payload.listObjectInsured.name
        customerInfoTab.form.formData.formInsuranceBuyer.identificationNumber =
          action.payload.listObjectInsured.identificationNumber
        customerInfoTab.form.formData.formInsuranceBuyer.customerBirthDay = action.payload
          .listObjectInsured.birthday
          ? moment(action.payload.listObjectInsured.birthday, 'DD/MM/YYYY').format('YYYY/MM/DD')
          : ''
        customerInfoTab.form.formData.formInsuranceBuyer.gender =
          action.payload.listObjectInsured.gender.toString()
        customerInfoTab.form.formData.formInsuranceBuyer.addressName =
          action.payload.listObjectInsured.addressName
        customerInfoTab.form.formData.formInsuranceBuyer.phone =
          action.payload.listObjectInsured.phone
        customerInfoTab.form.formData.formInsuranceBuyer.mobile =
          action.payload.listObjectInsured.mobile
        customerInfoTab.form.formData.formInsuranceBuyer.email =
          action.payload.listObjectInsured.email
        customerInfoTab.form.formData.formInsuranceBuyer.customerType =
          action.payload.listObjectInsured.customerType
        customerInfoTab.form.formData.formInsuranceBuyer.customerSegment =
          action.payload.listObjectInsured.customerSegment

        customerInfoTab.form.formData.formInsuranceBuyer.creditContractNumber =
          action.payload.listObjectInsured.creditContractNumber
        customerInfoTab.form.formData.formInsuranceBuyer.loanAmount = action.payload
          .listObjectInsured.loanAmount
          ? formatter(action.payload.listObjectInsured.loanAmount)
          : null
        customerInfoTab.form.formData.formInsuranceBuyer.loanPurpose =
          action.payload.listObjectInsured.loanPurpose
        customerInfoTab.form.formData.formInsuranceBuyer.loanTime =
          action.payload.listObjectInsured.loanTime
        customerInfoTab.form.formData.formInsuranceBuyer.bank =
          action.payload.listObjectInsured.bank

        customerInfoTab.form.formData.formInsuranceBuyer.employeeCode = action.payload
          .listObjectInsured?.employeeCode
          ? action.payload.listObjectInsured?.employeeCode
          : null
        customerInfoTab.form.formData.formInsuranceBuyer.parentGroupCode = action.payload
          .listObjectInsured?.parentGroupCode
          ? action.payload.listObjectInsured?.parentGroupCode
          : null
      }
      return customerInfoState
    case 'UPDATEBUYERINFOBYRELATIONSHIP':
      const buyerInfoState = JSON.parse(JSON.stringify(state))
      let buyerInfoTab = buyerInfoState.find((o: any) => o.tabName == action.payload.tab)
      if (buyerInfoTab) {
        if (action.payload.relationship == '1') {
          buyerInfoTab.form.formData.formInsuranceBuyer.customerName =
            buyerInfoTab.form.formData.formObjectInsured[action.payload.objectSelected].customerName
          buyerInfoTab.form.formData.formInsuranceBuyer.identificationNumber =
            buyerInfoTab.form.formData.formObjectInsured[
              action.payload.objectSelected
            ].identificationNumber
          buyerInfoTab.form.formData.formInsuranceBuyer.customerBirthDay = buyerInfoTab.form
            .formData.formObjectInsured[action.payload.objectSelected].customerBirthDay
            ? buyerInfoTab.form.formData.formObjectInsured[action.payload.objectSelected]
                .customerBirthDay
            : null
          buyerInfoTab.form.formData.formInsuranceBuyer.gender = buyerInfoTab.form.formData
            .formObjectInsured[action.payload.objectSelected].gender
            ? buyerInfoTab.form.formData.formObjectInsured[
                action.payload.objectSelected
              ].gender.toString()
            : null
          buyerInfoTab.form.formData.formInsuranceBuyer.addressName =
            buyerInfoTab.form.formData.formObjectInsured[action.payload.objectSelected].addressName
          buyerInfoTab.form.formData.formInsuranceBuyer.phone =
            buyerInfoTab.form.formData.formObjectInsured[action.payload.objectSelected].mobile
          buyerInfoTab.form.formData.formInsuranceBuyer.mobile =
            buyerInfoTab.form.formData.formObjectInsured[action.payload.objectSelected].mobile
          buyerInfoTab.form.formData.formInsuranceBuyer.email =
            buyerInfoTab.form.formData.formObjectInsured[action.payload.objectSelected].email
        } else {
          buyerInfoTab.form.formData.formInsuranceBuyer.customerName = null
          buyerInfoTab.form.formData.formInsuranceBuyer.identificationNumber = null
          buyerInfoTab.form.formData.formInsuranceBuyer.customerBirthDay = null
          buyerInfoTab.form.formData.formInsuranceBuyer.gender = null
          buyerInfoTab.form.formData.formInsuranceBuyer.addressName = null
          buyerInfoTab.form.formData.formInsuranceBuyer.phone = null
          buyerInfoTab.form.formData.formInsuranceBuyer.mobile = null
          buyerInfoTab.form.formData.formInsuranceBuyer.email = null
        }
      }
      return buyerInfoState
    case 'UPDATEFORMSTATUS':
      const formStatusState = JSON.parse(JSON.stringify(state))
      let formStatusTab = formStatusState.find((o: any) => o.tabName == action.payload.tab)
      if (formStatusTab) {
        formStatusTab.form.formStatus = action.payload.status
        formStatusTab.form.formData.feeAdditional = action.payload.feeAdditional
      }
      return formStatusState
    case 'UPDATEGROUPDOMAINCODE':
      const groupDomainState = JSON.parse(JSON.stringify(state))
      let groupDomainTab = groupDomainState.find((o: any) => o.tabName == action.payload.tab)
      if (groupDomainTab) {
        groupDomainTab.businessProgramCode = action.payload.groupDomainCode
      }
      return groupDomainState
    case 'UPDATECONTRACTID':
      const contractState = JSON.parse(JSON.stringify(state))
      let contractTab = contractState.find((o: any) => o.tabName == action.payload.tab)
      if (contractTab) {
        contractTab.sellingContractId = action.payload.contractId
      }
      return contractState
    case 'UPDATECONTRACTOBJID':
      const contractObjState = JSON.parse(JSON.stringify(state))
      let contractObjTab = contractObjState.find((o: any) => o.tabName == action.payload.tab)
      if (contractObjTab) {
        if (action.payload.listObjId.length > 0) {
          let test = contractObjTab.form.formData.formObjectInsured.find((o: any) => !o.sumFee)
          if (test) {
            let arr = contractObjTab.form.formData.formObjectInsured.filter((o: any) => o.sumFee)
            arr.forEach((elem: any, i: number) => {
              let check = contractObjTab.form.formData.formObjectInsured.find(
                (o: any) => o.id == elem.id
              )
              check.id = action.payload.listObjId[i].value
            })
          } else {
            action.payload.listObjId.forEach((elem: any) => {
              contractObjTab.form.formData.formObjectInsured[elem.key].id = elem.value
            })
          }
        }
      }
      return contractObjState
    case 'GETCUSTOMERINFOBYIDENTITY':
      return state
    case 'SAVECUSTOMERINFOBYIDENTITY':
      const saveCustomerState = JSON.parse(JSON.stringify(state))
      let saveCustomerTab = saveCustomerState.find((o: any) => o.tabName == action.payload.tab)
      if (saveCustomerTab && action.payload.data.objectInsuredInfo) {
        saveCustomerTab.form.formData.formObjectInsured[
          action.payload.objectSelected
        ].customerName = action.payload.data.objectInsuredInfo.name
        saveCustomerTab.form.formData.formObjectInsured[action.payload.objectSelected].addressName =
          action.payload.data.objectInsuredInfo.addressName
        saveCustomerTab.form.formData.formObjectInsured[action.payload.objectSelected].gender =
          action.payload.data.objectInsuredInfo.gender.toString()
        saveCustomerTab.form.formData.formObjectInsured[action.payload.objectSelected].email =
          action.payload.data.objectInsuredInfo.email
        saveCustomerTab.form.formData.formObjectInsured[action.payload.objectSelected].mobile =
          action.payload.data.objectInsuredInfo.mobile
        saveCustomerTab.form.formData.formObjectInsured[
          action.payload.objectSelected
        ].customerBirthDay = action.payload.data.objectInsuredInfo.birthday
          ? moment(action.payload.data.objectInsuredInfo.birthday, 'DD/MM/YYYY').format(
              'YYYY/MM/DD'
            )
          : null

        if (
          saveCustomerTab.form.formData.formObjectInsured[action.payload.objectSelected]
            .packageCode &&
          action.payload.data.objectInsuredInfo.gender &&
          action.payload.data.objectInsuredInfo.birthday
        ) {
          let obj: any = {
            pricingPackageType: 1,
            packageCode:
              saveCustomerTab.form.formData.formObjectInsured[action.payload.objectSelected]
                .packageCode,
            gender: action.payload.data.objectInsuredInfo.gender,
            sellingContractId: null,
            dateOfBirth: action.payload.data.objectInsuredInfo.birthday,
            startTime: saveCustomerTab.form.formData.formObjectInsured[
              action.payload.objectSelected
            ].startDate
              ? moment(
                  saveCustomerTab.form.formData.formObjectInsured[action.payload.objectSelected]
                    .startDate,
                  'YYYY/MM/DD HH:mm'
                ).format('DD/MM/YYYY HH:mm')
              : null,
            expireTime: saveCustomerTab.form.formData.formObjectInsured[
              action.payload.objectSelected
            ].expireDate
              ? moment(
                  saveCustomerTab.form.formData.formObjectInsured[action.payload.objectSelected]
                    .expireDate,
                  'YYYY/MM/DD HH:mm'
                ).format('DD/MM/YYYY HH:mm')
              : null,
            addtionalBenefit:
              saveCustomerTab.form.formData.formObjectInsured[action.payload.objectSelected]
                .additionalBenefit.length > 0
                ? saveCustomerTab.form.formData.formObjectInsured[
                    action.payload.objectSelected
                  ].additionalBenefit.join(',')
                : '',
            coverage: '1',
            lossRatioRate: saveCustomerTab.form.formData.formObjectInsured[
              action.payload.objectSelected
            ].lossRatioRate
              ? saveCustomerTab.form.formData.formObjectInsured[action.payload.objectSelected]
                  .lossRatioRate
              : 0,
            exchangeRate: 0,
            amountOfPeople: 0,
            sumFee: 0,
            salary: 0,
            packageBenefitDtos: [],
            packageExtensionDtos: [],
          }
          calculatorFeeHelthCare(obj)
            .then((res: any) => {
              if (res && !res.isError) {
                let data = {
                  key: 'sumFee',
                  value: res.data.sumFee,
                  tab: action.payload.tab,
                  form: 'formObjectInsured',
                  objectSelected: action.payload.objectSelected,
                }
                action.asyncDispatch({type: 'ADDBANCASINFORS', payload: data})
              }
            })
            .catch((error) => {
              return
            })
        }
      }
      return saveCustomerState
    case 'ACTIVEFORMBANCAS':
      const activeFormState = JSON.parse(JSON.stringify(state))
      let activeFormTab = activeFormState.find((o: any) => o.tabName == action.payload.tab)
      if (activeFormTab) {
        activeFormTab.form.activeForm = action.payload.form
      }
      return activeFormState
    case 'GETBUYERINFOBYIDENTITY':
      return state
    case 'SAVEBUYERINFOBYIDENTITY':
      const saveBuyerState = JSON.parse(JSON.stringify(state))
      let saveBuyerTab = saveBuyerState.find((o: any) => o.tabName == action.payload.tab)
      if (saveBuyerTab && action.payload.data.objectInsuredInfo) {
        saveBuyerTab.form.formData.formInsuranceBuyer.customerName =
          action.payload.data.objectInsuredInfo.name
        saveBuyerTab.form.formData.formInsuranceBuyer.customerBirthDay = action.payload.data
          .objectInsuredInfo.birthday
          ? moment(action.payload.data.objectInsuredInfo.birthday, 'DD/MM/YYYY').format(
              'YYYY/MM/DD'
            )
          : null
        saveBuyerTab.form.formData.formInsuranceBuyer.gender =
          action.payload.data.objectInsuredInfo.gender.toString()
        saveBuyerTab.form.formData.formInsuranceBuyer.taxNumber =
          action.payload.data.objectInsuredInfo.taxNumber
        saveBuyerTab.form.formData.formInsuranceBuyer.addressName =
          action.payload.data.objectInsuredInfo.addressName
        saveBuyerTab.form.formData.formInsuranceBuyer.phone =
          action.payload.data.objectInsuredInfo.phone
        saveBuyerTab.form.formData.formInsuranceBuyer.mobile =
          action.payload.data.objectInsuredInfo.mobile
        saveBuyerTab.form.formData.formInsuranceBuyer.email =
          action.payload.data.objectInsuredInfo.email
        saveBuyerTab.form.formData.formInsuranceBuyer.employeeCode = action.payload
          .objectInsuredInfo?.employeeCode
          ? action.payload.objectInsuredInfo?.employeeCode
          : null
        saveBuyerTab.form.formData.formInsuranceBuyer.parentGroupCode = action.payload
          .objectInsuredInfo?.parentGroupCode
          ? action.payload.objectInsuredInfo?.parentGroupCode
          : null
      }
      return saveBuyerState
    case 'UPDATECUSTOMERID':
      const customerIdState = JSON.parse(JSON.stringify(state))
      let customerIdTab = customerIdState.find((o: any) => o.tabName == action.payload.tab)
      if (customerIdTab) {
        if (!action.payload.id || action.payload.id.length == 0) return
        action.payload.id.forEach((element: any) => {
          let test = customerIdTab.form.formData.formObjectInsured.find(
            (o: any) => o.identificationNumber == element.identificationNumber
          )
          if (!test) return
          test.id = element.id
        })
      }
      return customerIdState
    case 'UPDATEDISCOUNT':
      const updateDiscountState = JSON.parse(JSON.stringify(state))
      let updateDiscount = updateDiscountState.find((o: any) => o.tabName == action.payload.tab)
      if (updateDiscount) {
        updateDiscount.form.formData.voucher = action.payload.voucher
        updateDiscount.form.formData.discount = action.payload.discount
      }
      return updateDiscountState
    case 'UPDATECARINFOBANCAS':
      const updateCarInfoState = JSON.parse(JSON.stringify(state))
      let updateCarInfo = updateCarInfoState.find((o: any) => o.tabName == action.payload.tab)
      if (updateCarInfo) {
        updateCarInfo.form.formData.formObjectInsured[action.payload.objectSelected].payload =
          action.payload.payload
        updateCarInfo.form.formData.formObjectInsured[action.payload.objectSelected].price =
          action.payload.price
        updateCarInfo.form.formData.formObjectInsured[action.payload.objectSelected].seat =
          action.payload.seat
        updateCarInfo.form.formData.formObjectInsured[action.payload.objectSelected].capacity =
          action.payload.capacity
        updateCarInfo.form.formData.formObjectInsured[action.payload.objectSelected].flueType =
          action.payload.flueType
        updateCarInfo.form.formData.formObjectInsured[action.payload.objectSelected].engineType =
          action.payload.engineType
        updateCarInfo.form.formData.formObjectInsured[
          action.payload.objectSelected
        ].manufacturingYear = action.payload.manufacturingYear
      }
      return updateCarInfoState
    default:
      return state
  }
}

export function* saga() {
  yield takeLatest('GETPERSONINSUREDBYID', function* getPersonInsuredByIdSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredById, action.payload)
      if (response && !response.isError) {
        yield put(actions.savePersonInsuredById(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETCARBANCASINSUREDBYID', function* getCarInsuredByIdSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredCarByID, action.payload)
      if (response && !response.isError) {
        yield put(actions.saveCarInsuredById(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETMOTOBANCASINSUREDBYID', function* getMotoInsuredByIdSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step2GetObjectInsuredMotoByID, action.payload)
      if (response && !response.isError) {
        yield put(actions.saveMotoInsuredById(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETHOUSEBANCASINSUREDBYID', function* getHouseInsuredByIdSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(getHouseInsuredById, action.payload)
      if (response && !response.isError) {
        yield put(actions.saveHouseInsuredById(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETCUSTOMERINFOBYIDENTITY', function* getCustomerByIdSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredByIdentity, action.payload.id)
      if (response && !response.isError) {
        let obj = {
          tab: action.payload.tab,
          objectSelected: action.payload.objectSelected,
          data: response.data,
        }
        yield put(actions.saveCustomerById(obj))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETCUSTOMERINFOBYIDENTITY', function* getCustomerByIdSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredByIdentity, action.payload.id)
      if (response && !response.isError) {
        let obj = {
          tab: action.payload.tab,
          objectSelected: action.payload.objectSelected,
          data: response.data,
        }
        yield put(actions.saveCustomerById(obj))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETBUYERINFOBYIDENTITY', function* getBuyerByIdSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredByIdentity, action.payload.id)
      if (response && !response.isError) {
        let obj = {
          tab: action.payload.tab,
          data: response.data,
        }
        yield put(actions.saveBuyerById(obj))
      }
    } catch (error) {
      return
    }
  })
}
